'use client';

import { useContext } from 'react';

import {
  ChatMessageContext,
  type ChatMessageContextValue,
} from '../contexts/chat-messages/context';

export function useChatMessageContext(): ChatMessageContextValue {
  const ctx = useContext(ChatMessageContext);
  if (ctx == null) {
    throw new Error('useChatMessageContext must be used inside <ChatProvider>');
  }
  return ctx;
}
